import DocumentApi from "../api/documentApi";
import * as ajax from "./ajaxCounterActions";

export function getContent(dossierId, tabName) {
	return function (dispatch) {
		dispatch(ajax.started());
		let result;
		return DocumentApi.getContent(dossierId, tabName)
			.then(response => {
				dispatch(ajax.ended());
				return {
					success: true,
					data: response.data
				};
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				return {
					success: false,
					data: error
				};
			});
	};
}

export function getVoortgangsrapportContent(voortgangsrapportId, tabName) {
	return function (dispatch) {
		dispatch(ajax.started());
		let result;
		return DocumentApi.getVoortgangsrapportContent(voortgangsrapportId, tabName)
			.then(response => {
				dispatch(ajax.ended());
				return {
					success: true,
					data: response.data
				};
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				return {
					success: false,
					data: error
				};
			});
	};
}

export function getContentWithoutLoading(dossierId, tabName) {
	return function (dispatch) {
		let result;
		return DocumentApi.getContent(dossierId, tabName)
			.then(response => {
				return {
					success: true,
					data: response.data
				};
			})
			.catch(error => {
				return {
					success: false,
					data: error
				};
			});
	};
}

export function getSjablonen(tabName) {
	return function (dispatch) {
		dispatch(ajax.started());
		let result;
		return DocumentApi.getSjablonen(tabName)
			.then(response => {
				dispatch(ajax.ended());
				return {
					success: true,
					data: response.data
				};
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				return {
					success: false,
					data: error
				};
			});
	};
}

export function getVoortgangsrapportSjablonen(tabName) {
	return function (dispatch) {
		dispatch(ajax.started());
		let result;
		return DocumentApi.getVoortgangsrapportSjablonen(tabName)
			.then(response => {
				dispatch(ajax.ended());
				return {
					success: true,
					data: response.data
				};
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				return {
					success: false,
					data: error
				};
			});
	};
}

export function getInfrastructuurContent(dossierId, tabName, infrastructuurId) {
	return function (dispatch) {
		dispatch(ajax.started());
		let result;
		return DocumentApi.getInfrastructuurContent(dossierId, tabName, infrastructuurId)
			.then(response => {
				dispatch(ajax.ended());
				return {
					success: true,
					data: response.data
				};
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				return {
					success: false,
					data: error
				};
			});
	};
}

export function uploadDocument(dossierId, tabName, componentName, data) {
	return function (dispatch) {
		dispatch(ajax.started());
		let result;
		return DocumentApi.uploadDocument(dossierId, tabName, componentName, data)
			.then(response => {
				dispatch(ajax.ended());
				return {
					success: true
				};
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				return {
					success: false,
					data: error
				};
			});
	};
}

export function uploadVoortgangsrapportDocument(voortgangsrapportId, tabName, componentName, data) {
	return function (dispatch) {
		dispatch(ajax.started());
		let result;
		return DocumentApi.uploadVoortgangsrapportDocument(voortgangsrapportId, tabName, componentName, data)
			.then(response => {
				dispatch(ajax.ended());
				return {
					success: true
				};
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				return {
					success: false,
					data: error
				};
			});
	};
}

export function uploadInfrastructuurDocument(dossierId, tabName, componentName, infrastructuurId, data) {
	return function (dispatch) {
		dispatch(ajax.started());
		let result;
		return DocumentApi.uploadInfrastructuurDocument(dossierId, tabName, componentName, infrastructuurId, data)
			.then(response => {
				dispatch(ajax.ended());
				return {
					success: true
				};
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				return {
					success: false,
					data: error
				};
			});
	};
}

export function deleteDocument(dossierId, tabName, componentName, filename) {
	return function (dispatch) {
		dispatch(ajax.started());
		let result;
		return DocumentApi.deleteDocument(dossierId, tabName, componentName, filename)
			.then(response => {
				dispatch(ajax.ended());
				return {
					success: true
				};
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				return {
					success: false,
					data: error
				};
			});
	};
}

export function deleteVoortgangsrapportDocument(voortgangsrapportId, tabName, componentName, filename) {
	return function (dispatch) {
		dispatch(ajax.started());
		let result;
		return DocumentApi.deleteDocument(voortgangsrapportId, tabName, componentName, filename)
			.then(response => {
				dispatch(ajax.ended());
				return {
					success: true
				};
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				return {
					success: false,
					data: error
				};
			});
	};
}

export function deleteInfrastructuurDocument(dossierId, tabName, componentName, infrastructuurId, filename) {
	return function (dispatch) {
		dispatch(ajax.started());
		let result;
		return DocumentApi.deleteInfrastructuurDocument(dossierId, tabName, componentName, infrastructuurId, filename)
			.then(response => {
				dispatch(ajax.ended());
				return {
					success: true
				};
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				return {
					success: false,
					data: error
				};
			});
	};
}

export function startFileSession(dossierId, tabName) {
	return function (dispatch) {
		dispatch(ajax.started());
		let result;
		return DocumentApi.startFileSession(dossierId, tabName)
			.then(response => {
				dispatch(ajax.ended());
				return {
					success: true
				};
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				return {
					success: false,
					data: error
				};
			});
	};
}

export function startInfrastructuurFileSession(dossierId, tabName, infrastructuurId) {
	return function (dispatch) {
		dispatch(ajax.started());
		let result;
		return DocumentApi.startInfrastructuurFileSession(dossierId, tabName, infrastructuurId)
			.then(response => {
				dispatch(ajax.ended());
				return {
					success: true
				};
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				return {
					success: false,
					data: error
				};
			});
	};
}

export function startVoortgangsrapportFileSession(tabName, voortgangsrapportId) {
	return function (dispatch) {
		dispatch(ajax.started());
		let result;
		return DocumentApi.startVoortgangsrapportFileSession(tabName, voortgangsrapportId)
			.then(response => {
				dispatch(ajax.ended());
				return {
					success: true
				};
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				return {
					success: false,
					data: error
				};
			});
	};
}

export function endFileSession(dossierId, tabName) {
	return function (dispatch) {
		dispatch(ajax.started());
		let result;
		return DocumentApi.endFileSession(dossierId, tabName)
			.then(response => {
				dispatch(ajax.ended());
				return {
					success: true
				};
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				return {
					success: false,
					data: error
				};
			});
	};
}

export function endInfrastructuurFileSession(dossierId, tabName, infrastructuurId) {
	return function (dispatch) {
		dispatch(ajax.started());
		let result;
		return DocumentApi.endInfrastructuurFileSession(dossierId, tabName, infrastructuurId)
			.then(response => {
				dispatch(ajax.ended());
				return {
					success: true
				};
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				return {
					success: false,
					data: error
				};
			});
	};
}

export function endVoortgangsrapportFileSession(tabName, voortgangsrapportId) {
	return function (dispatch) {
		dispatch(ajax.started());
		let result;
		return DocumentApi.endVoortgangsrapportFileSession(tabName, voortgangsrapportId)
			.then(response => {
				dispatch(ajax.ended());
				return {
					success: true
				};
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				return {
					success: false,
					data: error
				};
			});
	};
}


